import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].GET_EQUIPMENT_DOCUMENTS]: {
		url: '/company/:companyId/equipment/:equipmentId/documents/',
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].GET_EQUIPMENT_DOCUMENT]: {
		url: '/company/:companyId/equipment/:equipmentId/documents/:documentId/',
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].CREATE_EQUIPMENT_DOCUMENT]: {
		url: '/company/:companyId/equipment/:equipmentId/documents/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].PATCH_EQUIPMENT_DOCUMENT]: {
		url: '/company/:companyId/equipment/:equipmentId/documents/:documentId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].PUT_EQUIPMENT_DOCUMENT]: {
		url: '/company/:companyId/equipment/:equipmentId/documents/:documentId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].DELETE_EQUIPMENT_DOCUMENT]: {
		url: '/company/:companyId/equipment/:equipmentId/documents/:documentId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
